import styled from 'styled-components'
import { rem } from 'polished'

const ContentContainer = styled.main`
  align-items: center;
  display: flex;
  flex-direction: column;
  height: 100%;
  justify-content: center;
  max-width: ${(p) => rem(p.theme.mediaSizes.medium)};
  position: relative;
  width: 100%;

  @media (min-height: 650px) and (min-width: ${(p) =>
      p.theme.mediaSizes.medium}px) {
    background: linear-gradient(to right, #0d7988, #04313d);
    border-radius: ${(p) => p.theme.radius(0)};
    padding: ${(p) => p.theme.spacing(2)};
  }
`

export default ContentContainer



// WEBPACK FOOTER //
// ./src/components/ContentContainer.js